import { useEffect, useState } from "react";
import Input from "../../../utils/components/Input";
import Modal from "../../../utils/components/Modal";
import Textarea from "../../../utils/components/Textarea";
import Button from "../../../utils/components/Button";
import API from "../../../utils/API";
import { BsImageAlt } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { setProjects } from "../../../utils/redux/app/appActions";

const NewProjectModal = ({ translate, show, selectedProject, hideModal }) => {
  const [project, setProject] = useState(selectedProject);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const updateProjects = () => {
    dispatch(setProjects());
  };

  const handleChange = (e) => {
    setProject({
      ...project,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (e) => {
    let file = e.target.files[0];
    let reader = new FileReader();

    reader.onloadend = function () {
      setProject({
        ...project,
        logo: reader.result,
      });
    };
    reader.readAsDataURL(file);
  };

  const deleteProjectLogo = () => {
    setProject({
      ...project,
      logo: null,
    });
  };

  const putProject = (payload) => {
    let url = "/project/" + selectedProject.id;
    API.putData(url, payload).then(({ data: res }) => {
      updateProjects();
      if (res.data.name) {
        hideModal("success");
        setLoading(false);
      }
    });
  };

  const postProject = (payload) => {
    API.postData("/projects", payload).then(({ data: res }) => {
      updateProjects();
      if (res.data.name) {
        hideModal("success");
        setLoading(false);
      }
    });
  };

  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    const payload = {
      name: project.name,
      code: project.code,
      desc: project.description,
      logo: project.logo ? project.logo : "",
    };

    if (project.id) {
      putProject(payload);
    } else if (project.name) {
      postProject(payload);
    }
  };

  useEffect(() => {
    if (!show) {
      document.forms[0].reset();
      setProject({ logo: null, name: "", code: "", description: "" });
    }
  }, [show]);

  return (
    <div className="new-project-modal">
      <Modal
        title={
          selectedProject.name
            ? translate("projects.update_project.title")
            : translate("projects.new_project.title")
        }
        positiveButtonNode={translate("apply")}
        negativeButtonNode={translate("cancel")}
        positiveButtonHandler={handleSubmit}
        modalSize="lg"
        show={show}
        setShow={hideModal}
        disableButtons={loading}
      >
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-12 col-md-4 mt-2">
              <div className="input-group">
                <label
                  className="form-label text-uppercase fw-bold pb-0"
                  htmlFor="project-logo"
                >
                  {translate("projects.uppercase_translates.project_logo")}
                </label>
                <fieldset className="project-logo-area w-100">
                  <label
                    htmlFor="project-logo"
                    className="w-100 d-flex justify-content-center align-items-center"
                  >
                    {project.logo ? (
                      <img
                        src={project.logo}
                        alt="Project Logo"
                        className="w-100"
                      />
                    ) : (
                      <span className="icon rounded-circle d-flex justify-content-center align-items-center">
                        <BsImageAlt/>
                      </span>
                    )}
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    name="project-logo"
                    id="project-logo"
                    className="d-none"
                    onChange={handleFileChange}
                  />
                </fieldset>
                {project.logo && (
                  <Button
                    className="btn btn-danger mt-2"
                    onClick={deleteProjectLogo}
                  >
                    {translate("projects.new_project.delete_project_logo")}
                  </Button>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col mt-4">
              <Input
                type="text"
                title={translate("projects.uppercase_translates.project_name")}
                placeholder={translate(
                  "projects.new_project.project_name_placeholder",
                )}
                inputProps={{ name: "name" }}
                onChange={handleChange}
                defaultValue={project?.name}
              />
            </div>
          </div>

          <div className="row">
            <div className="col mt-4">
              <Input
                type="text"
                title={translate("projects.uppercase_translates.project_code")}
                placeholder={translate(
                  "projects.new_project.project_code_placeholder",
                )}
                inputProps={{ name: "code" }}
                onChange={handleChange}
                defaultValue={project?.code}
              />
            </div>
          </div>
          <div className="row">
            <div className="col mt-4">
              <Textarea
                title={translate(
                  "projects.uppercase_translates.project_description",
                )}
                placeholder={translate(
                  "projects.new_project.project_description_placeholder",
                )}
                rows={3}
                textareaProps={{ name: "description", onChange: handleChange }}
                defaultValue={project?.description}
              />
            </div>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default NewProjectModal;
